export enum StorageKeysEnum {
    preauthorizeToken = 'next-preauthorizeToken',
    preauthorizeTokenExpirationTime = 'next-preauthorizeTokenExpirationTime',
    accessToken = 'next-accessToken',
    accessTokenExpirationTime = 'next-accessTokenExpirationTime',
    refreshToken = 'next-refreshToken',
    refreshTokenExpirationTime = 'next-refreshTokenExpirationTime',
    role = 'next-ROLE',
    user = 'next-USER',
    userBrands = 'next-USER-BRANDS',
    uuid = 'next-uuid',
    company = 'next-COMPANY',
    settings = 'next-SETTINGS',
    genericActivitiesFilter = 'next-genericActivitiesFilter',
    genericMessages = 'next-genericMessages',
    taskPaginationSize = 'next-taskPaginationSize',
    taskByUserPaginationSize = 'next-taskByUserPaginationSize',
    workshiftModelPaginationSize = 'next-workshiftModelPaginationSize',
    workshiftPaginationSize = 'next-workshiftPaginationSize',
}
